import personnelEmbezzlementFA from './fa/fa.json'

const PersonnelEmbezzlementMessages = {
  fa: { ...personnelEmbezzlementFA },
}

export default PersonnelEmbezzlementMessages
